import {
	FORUM_CATEGORIES_ERROR,
	FORUM_CATEGORIES_GET,
	FORUM_GET,
	FORUM_LOADING_STATUS,
	FORUM_COMMENTS_GET_ERROR,
	FORUM_COMMENTS_GET,
	FORUM_COMMENT_ADD_STATUS,
	FORUM_COMMENT_ADD,
	FORUM_COMMENT_ADD_ERROR,
	FORUM_COMMENT_LIKE,
	FORUM_COMMENT_DELETE,
	FORUM_COMMENT_REPLY,
	FORUM_POST_ADD_STATUS,
	FORUM_POST_ADD,
	FORUM_POST_ADD_ERROR,
	FORUM_CHOSE_CATEGORY,
	FORUM_CHOSE_CATEGORY_DELETE,
	FORUMS_GET,
	FORUM_EDIT_LOADING_STATUS,
	FORUM_ACTIVE_COMMENT,
    FORUM_MODAL_CATEGORY,
    FORUM_MODAL_CATEGORY_LOADING
} from '@/store/forum/types'

const initialState = {
	loading: false,
	forumBeingEdited: false,

	categories: [],
	chosenCategory: undefined,
    modalCategories:[],
    isLocalLoading: false,
    forums: [],
	forum: {},
	comments: [],
	pageCount: {
		forumCategories: 0,
		forums: 0,
        modal: 0,
	},
	errors: [],
	commentAdding: false,
	activeCommentCount: 0,
}

export const state = { ...initialState }

export default {
    [FORUM_MODAL_CATEGORY_LOADING]:(state, payload) => {
        state.isLocalLoading = payload
    },
    [FORUM_MODAL_CATEGORY]:(state, payload) => {
        state.modalCategories = [...payload.data]
        state.pageCount.modal = +payload.pageCount
    },
	[FORUM_ACTIVE_COMMENT]: (state, payload) => {
		if (payload) {
			state.activeCommentCount++
		} else if (state.activeCommentCount > 0) {
			state.activeCommentCount--
		}
	},
	[FORUM_LOADING_STATUS]: (state, status) => {
		state.loading = status
	},

	[FORUM_CATEGORIES_GET]: (state, payload) => {
		state.categories = [...payload.data]
		state.pageCount.forumCategories = +payload.pageCount
	},

	[FORUMS_GET]: (state, payload) => {
		state.forums = [...payload.data]
		state.pageCount.forums = +payload.pageCount
	},

	[FORUM_GET]: (state, payload) => {
		state.forum = payload
	},

	[FORUM_COMMENTS_GET]: (state, payload) => {
		state.comments = payload
	},

	[FORUM_CATEGORIES_ERROR]: (state, payload) => {
		state.errors = [...state.errors, payload]
	},
	[FORUM_COMMENTS_GET_ERROR]: (state, payload) => {
		state.errors = [...state.errors, payload]
	},

	[FORUM_CHOSE_CATEGORY]: (state, categoryId) => {
		state.chosenCategory = state.categories.find((item) => +item.category_id === +categoryId)
	},

	[FORUM_CHOSE_CATEGORY_DELETE]: (state) => {
		state.chosenCategory = undefined
	},

	[FORUM_COMMENT_ADD_STATUS]: (state, status) => {
		state.commentAdding = status
	},
	[FORUM_COMMENT_ADD_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},
	[FORUM_COMMENT_ADD]: (state, payload) => {
		state.comments = [payload, ...state.comments]
	},

	[FORUM_COMMENT_LIKE]: (state, { comment, payloadData }) => {
		const likedComment = (comments, targetId, commentData) => {
			return comments.map((comment) => {
				const { upvote, upvote_count } = commentData

				if (comment.thread_reply_id === targetId) {
					comment = { ...comment, upvote, upvote_count }
				} else if (comment.replies && comment.replies.length > 0) {
					comment.replies = likedComment(comment.replies, targetId, commentData)
				}

				return comment
			})
		}

		state.comments = [...likedComment(state.comments, comment.id, payloadData)]
	},
	[FORUM_COMMENT_REPLY]: (state, { payload, parentId }) => {
		const replyToComment = (comments, targetId, newReply) => {
			return comments.map((comment) => {
				if (comment.thread_reply_id === targetId) {
					comment.replies = [...comment.replies, newReply]
				} else if (comment.replies && comment.replies.length > 0) {
					comment.replies = replyToComment(comment.replies, targetId, newReply)
				}

				return comment
			})
		}

		state.comments = [...replyToComment(state.comments, parentId, payload)]
	},
	[FORUM_COMMENT_DELETE]: (state, comment) => {
		const deleteComment = (comments, targetId) => {
			return comments.filter((comment) => {
				if (comment.thread_reply_id === targetId) {
					return false
				} else if (comment.replies && comment.replies.length > 0) {
					comment.replies = deleteComment(comment.replies, targetId)
				}

				return true
			})
		}

		state.comments = [...deleteComment(state.comments, comment.id)]
	},

	[FORUM_POST_ADD_STATUS]: (state, status) => {
		state.loading = status
	},
	[FORUM_POST_ADD_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},
	[FORUM_POST_ADD]: (state, payload) => {
		state.forums = [payload, ...state.forums]
	},
	[FORUM_EDIT_LOADING_STATUS]: (state, payload) => {
		state.forumBeingEdited = payload
	},
}
